import React, { useState } from "react";
import { CSidebar, CButton } from "@coreui/react";
import { cilMenu } from "@coreui/icons";
import { CIcon } from "@coreui/icons-react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Topbar from "./topbar/Topbar";

const Layout = () => {
  const isInitiallySmallScreen =
    typeof window !== "undefined" && window.innerWidth < 768;
  const [visible, setVisible] = useState(!isInitiallySmallScreen);

  return (
    <div
      className="d-flex flex-column"
      style={{
        height: "100vh",
        overflow: "hidden", // prevent outer scroll
      }}
    >
      {/* Fixed Topbar */}
      <div style={{ height: "60px", flexShrink: 0 }}>
        <Topbar />
      </div>

      {/* Content container */}
      <div className="d-flex justify-content-center flex-grow-1 w-100">
        <div
          className="d-flex w-100"
          style={{
            maxWidth: "1680px",
            width: "100%",
            height: "100%",
          }}
        >
          {/* Sidebar */}
          <CSidebar
            className="bg-light d-md-block sidebar-position"
            visible={visible}
            onVisibleChange={(val) => setVisible(val)}
          >
            <Sidebar onSelect={() => setVisible(false)} />
          </CSidebar>

          {/* Scrollable main content */}
          <div
            className="flex-grow-1 d-flex flex-column"
            style={{
              height: "100%",
              overflow: "hidden", // disable scroll at this level
              marginTop: "80px",
              // backgroundColor:'red'
            }}
          >
            <div
              style={{
                flex: 1,
                overflowY: "auto", // only this scrolls
                padding: "1rem",
              }}
            >
              <CButton
                color="light"
                onClick={() => setVisible(!visible)}
                className="mb-3 d-lg-none ms-2  menu-button-position"
              >
                <CIcon icon={cilMenu} />
              </CButton>

              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
